<div class="px-6 py-4 w-full bg-aguacate-bg rounded-lg " [class.bg-aguacate-highlight]="cuenta?.seleccionado">
  <div class="flex flex-row justify-between items-center">
    <div><b>{{cuenta?.beneficiario_nombre}} {{cuenta?.beneficiario_apellido}} </b></div>
    <div style="display: flex; align-items: center; gap: 6px;">
      <!-- Ver -->
      <button type="button" (click)="verCuenta()"
        title="Ver"
        style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">search</mat-icon>
      </button>
      <!-- Editar -->
      <button type="button" (click)="actualizar()"
        title="Editar"
        style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">edit</mat-icon>
      </button>
      <!-- Eliminar -->
      <button type="button" (click)="inactivarCuenta()"
        title="Eliminar"
        style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">delete</mat-icon>
      </button>
    </div>
  </div>
  <br> <b>{{cuenta?.medioCriptomoneda_descripcion}}:</b> {{cuenta?.beneficiario_medio_recepcion}}
</div>
